var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"items":_vm.items,"isLoading":_vm.isLoading}),_c('LlPaginate',{attrs:{"value":_vm.page,"page-count":_vm.totalPage},on:{"input":function($event){return _vm.$_pageClick($event)}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }